import { API as e, Resource as t, SourceType as n } from "@coveo/platform-client";
//#region src/resources/LicenseInternalResource.ts
var r = [n.CUSTOM], i = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/license`;
	}
	async full() {
		let e = await this.api.get(n.baseUrl);
		return {
			...e,
			connectors: e.connectors.map((e) => ({
				...e,
				deprecated: r.includes(e.type)
			}))
		};
	}
};
//#endregion
export { i as LicenseInternalResource };

//# sourceMappingURL=LicenseInternalResource.js.map